import { library } from '@fortawesome/fontawesome-svg-core';

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

import {
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

import {
  faAd as falAd,
  faBolt as falBolt,
  faCamera as falCamera,
  faChartLine as falChartLine,
  faCheckCircle as falCheckCircle,
  faCircle as falCircle,
  faCog as falCog,
  faCopy as falCopy,
  faEnvelopeOpenDollar as falEnvelopeOpenDollar,
  faExclamationTriangle as falExclamationTriangle,
  faFile as falFile,
  faFileInvoiceDollar as falFileInvoiceDollar,
  faLayerPlus as falLayerPlus,
  faMoneyCheckEditAlt as falMoneyCheckEditAlt,
  faPhotoVideo as falPhotoVideo,
  faPlus as falPlus,
  faQuestion as falQuestion,
  faRectangleLandscape as falRectangleLandscape,
  faTrash as falTrash,
  faTrashAlt as falTrashAlt,
  faVideo as falVideo,
} from '@fortawesome/pro-light-svg-icons';

import {
  faCamera as farCamera,
  faCheckCircle as farCheckCircle,
  faCircle as farCircle,
  faChevronUp as farChevronUp,
  faExclamationCircle as farExclamationCircle,
  faHourglassHalf as farHourglassHalf,
  faInfoCircle as farInfoCircle,
  faImage as farImage,
  faPlusSquare as farPlusSquare,
  faPrint as farPrint,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faBadgeDollar as fasBadgeDollar,
  faChartLine as fasChartLine,
  faCheckCircle as fasCheckCircle,
  faChevronDown as fasChevronDown,
  faCompressAlt as fasCompressAlt,
  faEllipsisV as fasEllipsisV,
  faEnvelopeOpenDollar as fasEnvelopeOpenDollar,
  faExclamationCircle as fasExclamationCircle,
  faEye as fasEye,
  faFileImport as fasFileImport,
  faFileUser as fasFileUser,
  faFile as fasFile,
  faFileAlt as fasFileAlt,
  faFileImage as fasFileImage,
  faFileAudio as fasFileAudio,
  faFileVideo as fasFileVideo,
  faFilePdf as fasFilePdf,
  faFileArchive as fasFileArchive,
  faHomeLgAlt as fasHomeLgAlt,
  faLayerPlus as fasLayerPlus,
  faLightbulbOn as fasLightbulbOn,
  faListMusic as fasListMusic,
  faLongArrowAltDown as fasLongArrowAltDown,
  faLongArrowAltRight as fasLongArrowAltRight,
  faMoneyCheckEditAlt as fasMoneyCheckEditAlt,
  faObjectGroup as fasObjectGroup,
  faPhotoVideo as fasPhotoVideo,
  faRandom as fasRandom,
  faSave as fasSave,
  faShoppingCart as fasShoppingCart,
  faShieldCheck as fasShieldCheck,
  faSquare as fasSquare,
  faTimesCircle as fasTimesCircle,
  faTrash as fasTrash,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faLightbulbOn as fadLightbulbOn,
  faTabletAlt as fadTabletAlt,
} from '@fortawesome/pro-duotone-svg-icons';

// import {
// } from '@motionelements/assets/src/js/me-font/icons/me-font-icons-light.js';

// import {
// } from '@motionelements/assets/src/js/me-font/icons/me-font-icons-regular.js';

import {
  faMeUpload as fasMeUpload,
  faMeVr as fasMeVr,
  faMeGraphicTemplate as fasMeGraphicTemplate,
  faMeUiTemplate as fasMeUiTemplate,
  faMePresentationTemplate as fasMePresentationTemplate,
  faMeNotionTemplate as fasMeNotionTemplate,
  faMePrompt as fasMePrompt,
} from '@motionelements/assets/src/js/me-font/icons/me-font-icons-solid.js';

library.add(
  faYoutube,
  falBolt,
  falAd,
  falCamera,
  falChartLine,
  falCheckCircle,
  falCircle,
  falCog,
  falCopy,
  falEnvelopeOpenDollar,
  falExclamationTriangle,
  falFile,
  falFileInvoiceDollar,
  falLayerPlus,
  falMoneyCheckEditAlt,
  falPhotoVideo,
  falPlus,
  falQuestion,
  falRectangleLandscape,
  falTrash,
  falTrashAlt,
  falVideo,
  farCamera,
  farChevronUp,
  farCheckCircle,
  farCircle,
  farExclamationCircle,
  farHourglassHalf,
  farInfoCircle,
  farImage,
  farPlusSquare,
  farPrint,
  fasBadgeDollar,
  fasChartLine,
  fasCheckCircle,
  fasChevronDown,
  fasCompressAlt,
  fasEllipsisV,
  fasEnvelopeOpenDollar,
  fasExclamationCircle,
  fasEye,
  fasFileImport,
  fasFileUser,
  fasFile,
  fasFileAlt,
  fasFileImage,
  fasFileAudio,
  fasFileVideo,
  fasFilePdf,
  fasFileArchive,
  fasHomeLgAlt,
  fasLayerPlus,
  fasLightbulbOn,
  fasListMusic,
  fasLongArrowAltDown,
  fasLongArrowAltRight,
  fasMoneyCheckEditAlt,
  fasObjectGroup,
  fasPhotoVideo,
  fasRandom,
  fasSave,
  fasShoppingCart,
  fasShieldCheck,
  fasSquare,
  fasTimesCircle,
  fasTrash,
  fadLightbulbOn,
  fadTabletAlt,
  fasMeUpload,
  fasMeVr,
  fasMeGraphicTemplate,
  fasMeUiTemplate,
  fasMePresentationTemplate,
  fasMeNotionTemplate,
  fasMePrompt,
);

export default function install(Vue) {
  Vue.component('font-awesome-icon', FontAwesomeIcon);
  Vue.component('font-awesome-layers', FontAwesomeLayers);
  Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
}
